import React from 'react';
import dynamic from 'next/dynamic';
import useMobile from '@sls-react/hooks/useMobile';
import useChromelessContext from '@sls-react/contexts/ChromelessContext';

const MobileHeader = dynamic(
  () => import('@sls-react/components/Chrome/Header/Mobile/MobileHeader'),
);

const DesktopHeader = dynamic(
  () => import('@sls-react/components/Chrome/Header/Desktop/DesktopHeader'),
);

type Props = {
  excludeBanners?: boolean;
  excludeMobileSearch?: boolean;
};

const Header: React.FC<Props> = ({ excludeBanners, excludeMobileSearch }) => {
  const { isChromeless } = useChromelessContext();
  const isMobile = useMobile();

  if (isChromeless) {
    return null;
  }

  return isMobile ? (
    <MobileHeader
      hideSearch={excludeMobileSearch}
      hideBanners={excludeBanners}
    />
  ) : (
    <DesktopHeader />
  );
};

export default Header;
